import { useStore } from '@/store';
import React, { Suspense, useRef } from 'react';
import Art from '@/components/Art';
import Camera from '@/components/Camera';
import Person from '@/components/Person';
import { useCursor } from '@react-three/drei';
import Lights from '@/components/Lights';

const Scene: React.FC = () => {
  const refScene = useRef();
  const data = useStore((state) => state.data);
  const clickable = useStore((s) => s.clickable);
  useCursor(clickable);

  return (
    <>
      <Suspense fallback={null}>
        <scene ref={refScene}>
          <Camera />
          <Lights />
          <Person />
          {data.map((d) => (
            <Art datum={d} key={d.order} />
          ))}
        </scene>
      </Suspense>
    </>
  );
};

export default Scene;
